import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IdValuePair, LookupCriteria, MailingAddressViewModel } from "@tylertech/tyler-api-types";
import { ServiceAddressViewModel, UBAddAccountWizardServiceDTO } from "../interfaces";
@Injectable()
export class ServiceAddressService
{
    private readonly $apiService = inject(ApiService);


    Lookup(criteria: LookupCriteria): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth<LookupCriteria, IdValuePair[]>(
            "ILookupService/LookupServiceAddresses",
            criteria
        );
    }

    checkUnique(serviceAddressNumber: string): Promise<boolean>
    {
        return this.$apiService.sendAuth<string, boolean>("IServiceAddressService/CheckUnique", serviceAddressNumber);
    }

    createServiceAddress(newSA: ServiceAddressViewModel): Promise<string>
    {
        return this.$apiService.sendAuth<ServiceAddressViewModel, string>(
            "IServiceAddressService/CreateServiceAddress",
            newSA
        );
    }

    getServiceAddressAsMailingAddress(serviceAddressId: string): Promise<MailingAddressViewModel>
    {
        return this.$apiService.sendAuth<string, MailingAddressViewModel>(
            "IServiceAddressService/GetServiceAddressAsMailingAddress",
            serviceAddressId
        );
    }

    getServiceAddressSegmentMask(): Promise<string>
    {
        return this.$apiService.sendAuth<void, string>("IServiceAddressService/GetServiceAddressSegmentMask");
    }

    getServiceAddressSegmentRegexMask(): Promise<string>
    {
        return this.$apiService.sendAuth<void, string>("IServiceAddressService/GetServiceAddressSegmentRegexMask");
    }

    getServices(serviceAddressId: string): Promise<UBAddAccountWizardServiceDTO[]>
    {
        return this.$apiService.sendAuth<string, UBAddAccountWizardServiceDTO[]>(
            "IServiceAddressService/GetServices",
            serviceAddressId
        );
    }

    getNextServiceAddressNumber(readGroupCodeId: string): Promise<string>
    {
        return this.$apiService.sendAuth<string, string>(
            "IServiceAddressService/GetNextServiceAddressNumber",
            readGroupCodeId
        );
    }
}
